import apiInstance from "services/apiInstance";

const addSession = (params) => {
  return apiInstance.post(`/examSession`, params);
};

const editSession = (params) => {
  return apiInstance.put(`/examSession`, params);
};

const deleteSession = (examSessionId) => {
  return apiInstance.delete(`/examSession/delete/${examSessionId}`);
};

const getSessionStudents = (params) => {
  const { examId, sessionId } = params;
  return apiInstance.get(`/examSession/students/${examId}/${sessionId}`);
};

const getSessionStudentsCount = (params) => {
  const { sessionId } = params;
  return apiInstance.get(`/examSession/students/count/${sessionId}`);
};

const getRoomStudents = (params) => {
  const { examId, sessionId, roomId } = params;
  return apiInstance.get(`/examSession/students/${examId}/${sessionId}/${roomId}`);
};

const getSessionList = (examIdList) => {
  return apiInstance.post(`/examSession/search`, examIdList);
};

const getMultipleExamSessionList = (params) => {
  const { examIds, campusId } = params;
  return apiInstance.post(`/examSession/getMultiple/${campusId}`, examIds);
};

const getSessionInfoByIdentityNumber = (studentIdentityNumber) => {
  return apiInstance.get(`/scholarship/getApplication/${studentIdentityNumber}`);
};

const getSessionOpenedCities = () => {
  return apiInstance.get(`/scholarship/city`);
};

const getSessionOpenedLevelsByCityId = (params) => {
  const { cityId } = params;
  return apiInstance.get(`/scholarship/level/${cityId}`);
};

const getSessionOpenedSchoolsByCityIdAndLevelId = (params) => {
  const { cityId, levelId, schoolType } = params;
  return apiInstance.get(`/scholarship/school/${cityId}/${levelId}?schoolType=${schoolType}`);
};

const getSessionOpenedExamsByCityIdLevelIdAndSchoolId = (params) => {
  const { cityId, levelId, schoolId } = params;
  return apiInstance.get(`/scholarship/exam/${cityId}/${levelId}/${schoolId}`);
};

const getOpenedSessionsByCityIdLevelIdSchoolIdAndExamId = (params) => {
  const { cityId, levelId, schoolId, examId } = params;
  return apiInstance.get(`/scholarship/session/${cityId}/${levelId}/${schoolId}/${examId}`);
};

const addSessionStudent = (params) => {
  return apiInstance.post(`/scholarship/addApplication`, params);
};

const deleteSessionStudent = (params) => {
  const { identityNumber, examId } = params;
  return apiInstance.get(`/scholarship/cancelApplication/${identityNumber}/${examId}`);
};

const isSessionAllowed = (params) => {
  const { identityNumber, sessionId } = params;
  return apiInstance.get(`/scholarship/checkSession/${identityNumber}/${sessionId}`);
};

const isExamAllowed = (params) => {
  const { identityNumber, examId } = params;
  return apiInstance.get(`/scholarship/checkExam/${identityNumber}/${examId}`);
};

const getSessionApprovalFileURL = (params) => {
  const { schoolId, sessionId } = params;
  return apiInstance.get(`/scholarship/approval/${schoolId}/${sessionId}`);
};

const saveSessionApprovalLog = (sessionStudentId) => {
  return apiInstance.post(`/scholarship/approval/log/${sessionStudentId}`);
};

const getExamSessionStudentsInRange = (params) => {
  return apiInstance.post(`/examSession/studentsRange`, params);
};

const editExamSessionStudent = (params) => {
  return apiInstance.put(`/examSession/edit/student`, params);
};

const deleteExamSessionStudent = (sessionStudentId) => {
  return apiInstance.delete(`/examSession/delete/student/${sessionStudentId}`);
};

const getSessionStudentExamResult = (params) => {
  return apiInstance.post(`/scholarship/result`, params);
};

const getSessionStudentMultipleExamResult = (identityNumber) => {
  return apiInstance.get(`/scholarship/examResults/${identityNumber}`);
};

const getAssesmentMessage = (asssesmentIdList) => {
  return apiInstance.post(`/scholarship/assesmentMessage`, asssesmentIdList);
};

const examSessionAddStudents = (params) => {
  return apiInstance.post(`/examSession/addStudents`, params);
};

const examSessionRemoveStudents = (sessionId) => {
  return apiInstance.post(`/examSession/removeStudents/${sessionId}`);
};

const checkSessionStudentsExist = ({ examId, identityNumbers }) => {
  return apiInstance.post(`/examSession/students/checkExist/${examId}`, identityNumbers);
};

const getSessionStudentInfoByIdentityNumber = (studentIdentityNumber) => {
  return apiInstance.get(`/scholarship/getSessionStudent/${studentIdentityNumber}`);
};

const addEditSessionApproval = (params) => {
  return apiInstance.post(`/examSession/approval`, params);
};

const getSessionApproval = ({ campusId, examId }) => {
  return apiInstance.get(`/examSession/approval/${campusId}/${examId}`);
};

const deleteSessionApproval = ({ approvalId }) => {
  return apiInstance.delete(`/examSession/approval/${approvalId}`);
};

export {
  addSession,
  editSession,
  getSessionStudents,
  getSessionStudentsCount,
  getSessionList,
  deleteSession,
  getSessionInfoByIdentityNumber,
  getSessionOpenedCities,
  getSessionOpenedLevelsByCityId,
  getSessionOpenedSchoolsByCityIdAndLevelId,
  getSessionOpenedExamsByCityIdLevelIdAndSchoolId,
  getOpenedSessionsByCityIdLevelIdSchoolIdAndExamId,
  addSessionStudent,
  deleteSessionStudent,
  isSessionAllowed,
  getRoomStudents,
  getExamSessionStudentsInRange,
  deleteExamSessionStudent,
  editExamSessionStudent,
  getMultipleExamSessionList,
  isExamAllowed,
  getSessionStudentExamResult,
  getSessionStudentMultipleExamResult,
  getAssesmentMessage,
  examSessionAddStudents,
  examSessionRemoveStudents,
  checkSessionStudentsExist,
  getSessionStudentInfoByIdentityNumber,
  addEditSessionApproval,
  getSessionApproval,
  getSessionApprovalFileURL,
  saveSessionApprovalLog,
  deleteSessionApproval
};
